export default {
    buttons: {
        save: 'Save',
        go_to_location: 'Go to locations',
        change_password: 'Change password',
        change_email: 'Change email',
        eneter_email: 'Enter email',
        add_credentials: 'Add credentials',
        add_password: 'Add password',
        upload_profile_photo: 'Upload profile photo',
        change_phone: 'Change phone number',
        enter_phone: 'Enter phone number',
        verify_phone: 'Verify phone number',
        change: 'Change',
    },
    fields: {
        first_name: {
            label: 'First name',
            placeholder: 'John',
        },
        last_name: {
            label: 'Last name',
            placeholder: 'Jonhson',
        },
        username: {
            label: 'Username',
            placeholder: 'Must be unique',
        },
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        phone: {
            label: 'Phone number',
            placeholder: '+3811231231',
        },
        twitter: {
            label: 'X-Twitter',
            placeholder: 'Enter your X-Twitter url',
        },
        instagram: {
            label: 'Instagram',
            placeholder: 'Enter your Instagram url',
        },
        linkedin: {
            label: 'LinkedIn',
            placeholder: 'Enter your LinkedIn url',
        },
        facebook: {
            label: 'Facebook',
            placeholder: 'Enter your Facebook url',
        },
        description: {
            label: 'Description',
            placeholder: 'Description goes here...',
            description: 'This is public information that will be shown when you make reservation',
        },
        tiktok: {
            label: 'Tik tok',
            placeholder: 'Enter your Tik Tok url',
        },
        google: {
            label: 'Google Business',
            placeholder: 'Enter your Google Business url',
        },
    },
    messages: {
        confirm_email: 'Done! Check your email.',
        locations_not_set: 'You do not have any location set. Do you want to do it now?',
        mobile_not_set: 'Mobile phone is not set. Do you want to do it now?',
        no_offers_active: 'You don`t have active services.',
        no_offers_reneewal: 'You don`t have services for reneewal.',
        no_offers_expired: 'You don`t have expired services.',
        no_favorite_offers: 'There are currently no favorite services.',
    },
}
